export const APP_CONFIG = {
  name: 'Ghost Cable',
  tagline: 'Television that refuses to die.',
  emoji: '👻',
  icon: 'Ghost',
  defaultTheme: 'dark',
  defaultLoginRoute: '/customer/login',
};

export const AUTH_PROFILES = [
  {
    key: 'admin',
    name: 'Admin_c',
    profileSlug: "|xGrOtuyYXMktsUu5mmZd7wrY0kz51HsNXpPKDaX/9YQ=",
    redirectAfterAuth: '/admin',
    authPage: {
      loginTitle: 'Owner Sign In',
      signupTitle: 'Create Owner Account',
      loginDescription: null,
      signupDescription: null,
    },
    altLinksLeadIn: 'Go to the right portal',
    altLinks: [
      { href: '/staff/login', label: 'I am Staff' },
      { href: '/customer/login', label: 'I am Customer' }
    ],
    reportsTo: null,
    hasSignup: false,
  },
  {
    key: 'staff',
    name: 'Staff_c',
    profileSlug: "|xGrOtuyYXMktsUu5mmZd79YbqB9rlARVfpk6sT6ko9A=",
    redirectAfterAuth: '/admin',
    authPage: {
      loginTitle: 'Staff Sign In',
      signupTitle: 'Create Staff Account',
      loginDescription: null,
      signupDescription: null,
    },
    altLinksLeadIn: 'Go to the right portal',
    altLinks: [
      { href: '/admin/login', label: 'I am Owner' },
      { href: '/customer/login', label: 'I am Customer' }
    ],
    reportsTo: "Admin_c",
    hasSignup: false,
  },
  {
    key: 'customer',
    name: 'Customer_c',
    profileSlug: "|xGrOtuyYXMktsUu5mmZd78spy7YFp2hMZo/Fw3nzqMg=",
    redirectAfterAuth: '/account',
    authPage: {
      loginTitle: 'Customer Sign In',
      signupTitle: 'Create Customer Account',
      loginDescription: null,
      signupDescription: null,
    },
    altLinksLeadIn: 'Go to the right portal',
    altLinks: [
      { href: '/admin/login', label: 'I am Owner' },
      { href: '/staff/login', label: 'I am Staff' }
    ],
    reportsTo: "Admin_c",
    hasSignup: true,
  }
];

export const GENERIC_AUTH = {
  loginTitle: 'Welcome back',
  signupTitle: 'Create your Ghost Cable account',
  loginDescription: null,
  signupDescription: null,
  redirectAfterAuth: '/account',
};
